import { render } from "./BaseSection.vue?vue&type=template&id=7f6d400a&scoped=true"
import script from "./BaseSection.vue?vue&type=script&lang=js"
export * from "./BaseSection.vue?vue&type=script&lang=js"

import "./BaseSection.vue?vue&type=style&index=0&id=7f6d400a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f6d400a"]])

export default __exports__